import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
import { RANDOM_BUYERS } from '../lib/content';
export function SoldPopup() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(RANDOM_BUYERS[0]);
  const [minutesAgo, setMinutesAgo] = useState(3);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      const b = RANDOM_BUYERS[Math.floor(Math.random() * RANDOM_BUYERS.length)];
      setBuyer(b);
      setMinutesAgo(Math.floor(Math.random() * 12) + 1);
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const first = setTimeout(show, 4000);
    const loop = setInterval(show, 13000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(loop);
    };
  }, []);
  return <AnimatePresence data-id="element-167">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 40,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 40
    }} transition={{
      duration: 0.35
    }} className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-xs" data-id="element-168">
          <div className="flex items-center gap-3 rounded-xl border border-orange-500/40 bg-neutral-900 p-3 shadow-2xl" data-id="element-169">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-orange-500/20" data-id="element-170">
              <CheckCircleIcon className="h-5 w-5 text-orange-400" data-id="element-171" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-172">
              <p className="text-sm font-bold text-white" data-id="element-173">
                {buyer.name}{' '}
                <span className="font-normal text-neutral-400" data-id="element-174">
                  just purchased
                </span>
              </p>
              <p className="truncate text-xs text-neutral-400" data-id="element-175">
                Basketball Resolved · {buyer.city} · {minutesAgo} min ago
              </p>
            </div>
            <button onClick={() => setVisible(false)} aria-label="Close notification" className="shrink-0 text-neutral-500 hover:text-white" data-id="element-176">
              <XIcon className="h-4 w-4" data-id="element-177" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}